import React, { useEffect, useState } from 'react';
import Cookies from "universal-cookie";
import { folders } from '../../assets/svg/folder-svg';
import { deleteEmails, permanentlyDeleteEmail, updateAttribute, updateEmailAttributeValue } from '../../helper/emailHelper.js';
import { updateInsecureMail } from '../../service/api-actions.js';
import "../../assets/css/calendar.css";
import { Archive, FolderInput, Trash2, MailOpen, Mail, Reply, ReplyAll, Forward, Inbox } from 'lucide-react';
import Swal from 'sweetalert2';
import { message } from 'antd';
import { removeMessageFromIndexedDb } from '../../db/indexed-helper.js';
import { reportError, toErrorString } from '../../utils/errorLogger.js';
import { notifyChainFailure } from '../../utils/txFeedback.js';
const cookies = new Cookies();

function getColorFromJson(jsonString) {

    try {
        const json = jsonString;
        const color = json.folderProperties.find(value => value.key == 'color')['value']
        return color;
    } catch (error) {
        return "green";
    }

}

const ContextMenu = ({ x, y, onClose, types, selectedContext, loader, pageType, reRender, text, messageList, actionClick, openCreateFolder }) => {
    const [visible, setVisible] = useState(true);
    const [markAsReadList, setMarkAsReadList] = useState(false)
    const [user] = useState(cookies.get("userObject"));
    const isArchive = ["Important", "Inbox", "Sent"].includes(pageType);
    const userName = localStorage.getItem('UserName');

    // Function to handle click outside of the context menu
    const handleClickOutside = (event) => {
        if (!event.target.closest('.contextMenu')) {
            onClose();
            setVisible(true)
        }
    };
    React.useEffect(() => {
        if (selectedContext.isRead === false) {
            setMarkAsReadList(true)
        }
        else {
            setMarkAsReadList(false)
        }
    }, [selectedContext])
    // Attach click event listener to handle clicks outside of the context menu
    React.useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // Style object to position the context menu
    const style = {
        position: 'fixed',
        left: x,
        top: y,
        background: 'white'
    };

    // Function to handle context menu option click
    const handleOptionClick = async (folderName) => {
        const type = pageType === 'Sent' ? `sent-folder-${parseInt(folderName.id)}` : `inbox-folder-${parseInt(folderName.id)}`;
        loader(true);
        text("Please wait, your email is being moved, Going forward it will be fast.")
        let ok = true;
        if (pageType === "Insecure") {
            await updateAttribute(user.name, [selectedContext.physmessage_id], type, 'folder', true);
        } else {
            ok = await updateEmailAttributeValue(user.name, [selectedContext.id], [{ key: 'folder', value: (folderName.id).toString() }], 'hostContract');
        }
        loader(false);
        text("")
        if (!ok) notifyChainFailure(`move this email to "${folderName.name || 'that folder'}"`);
        reRender();
        onClose(); // Close the context menu
    };

    const handleRestore = async () => {
        loader(true);
        text("Please wait, your email is being restored, Going forward it will be fast.")
        const ok = await deleteEmails(selectedContext, null, null, null, selectedContext.emailType, null);
        loader(false);
        text("")
        if (!ok) notifyChainFailure('restore this email');
        reRender();
        onClose();
    };


    const handleweb2emails = async (id, value) => {
        loader(true);
        try {
            await updateInsecureMail("Web2emails", [id], value);
            reRender();
        } catch (error) {
            const errorStr = toErrorString(error || error.message);
            reportError({
                endpoint: '/updateInsecureMail',
                message: `FileName: ContextMenu.js, Fun: handleweb2emails, ${String(error.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error("Error while updating email:", error);
        } finally {
            loader(false);
        }
    };
    const handleArchive = async (value) => {
        loader(true);
        text("Please wait, your email is being moved to the archive list, Going forward it will be fast.")
        const ok = await updateEmailAttributeValue(user.name, [selectedContext.id], [{ key: 'isArchive', value: (value).toString() }], 'hostContract');
        loader(false);
        text("")
        if (!ok) notifyChainFailure(value ? 'archive this email' : 'move this email to the inbox');
        reRender();
        onClose();
    };


    const restoreweb2email = async (id) => {
        const value = 2;
        loader(true);
        text("Please wait, your email is being restored, Going forward it will be fast.")
        await updateInsecureMail("deleteemail", id, value);
        reRender();
        onClose();
    }
    /** The modal is owned by the list component; this menu is about to unmount. */
    const handleFolder = () => {
        onClose();
        if (openCreateFolder) openCreateFolder();
    };

    const handleSingleDelete = (message) => {
        const response = message.mailtype
        Swal.fire({
            text: "Are you sure you want to delete this email?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#7f7f7f",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const value = 1;
                    loader(true);
                    text("Please wait, your email is being deleted, Going forward it will be fast.")
                    if (response === "web2emails") {
                        await updateInsecureMail('deleteemail', message.id, value);
                    }
                    else if (response === "web3emails" || response === "Senttrash") {
                        const ok = await deleteEmails(null, [message.id], null, null, pageType, null)
                        if (!ok) notifyChainFailure('delete this email');
                    }

                }
                catch (err) {
                    const errorStr = toErrorString(err || err.message);
                    reportError({
                        endpoint: '/updateInsecureMail',
                        message: `FileName: ContextMenu.js, Fun: handleSingleDelete, ${String(err.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    console.log(err);
                }
                finally {
                    loader(false);
                    text("")
                    reRender();
                }
            }
        });

    }
    const deleteForever = (message) => {
        const response = message.mailtype
        Swal.fire({
            text: "Are you sure you want to delete this email?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1677ff",
            cancelButtonColor: "#ffffff",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            customClass: "compose-sweet-alert"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const value = 3;
                    loader(true);
                    text("Please wait, your email is being deleted, Going forward it will be fast.")
                    if (response === "web2emails") {
                        await updateInsecureMail('deleteemail', message.id, value);
                    }
                    else if (response === "web3emails" || response === "Senttrash") {
                        const hash = await permanentlyDeleteEmail(user.name, [message.messageId], 'hostContract')
                        if (!hash) notifyChainFailure('permanently delete this email');
                    }
                }
                catch (err) {
                    const errorStr = toErrorString(err || err.message);
                    reportError({
                        endpoint: '/updateInsecureMail',
                        message: `FileName: ContextMenu.js, Fun: deleteForever, ${String(err.message || 'Unhandled error')}`,
                        error: errorStr,
                        userName: userName || '',
                    });
                    console.log(err);
                }
                finally {
                    loader(false);
                    text("")
                    reRender();
                }
            }
        });
    }
    const handleReadEmail = async (message, type) => {
        try {
            loader(true);
            const response = message.mailtype;
            if (type === "read") {
                text("Please wait, your email is being read, Going forward it will be fast.");
                if (response === "web2emails") {
                    await updateInsecureMail('isRead', [message.id], 1);
                }
                else if (response === "web3emails") {
                    const ok = await updateEmailAttributeValue(user.name, [message.id], [{ key: "isRead", value: "true" }], 'hostContract');
                    if (!ok) notifyChainFailure('mark this email as read');
                }
            }
            else if (type === "unread") {
                text("Please wait, your email is being marked as unread, Going forward it will be fast.");
                if (response === "web2emails") {
                    await updateInsecureMail('isRead', [message.id], 0);
                }
                else if (response === "web3emails") {
                    const ok = await updateEmailAttributeValue(user.name, [message.id], [{ key: "isRead", value: "false" }], 'hostContract');
                    if (!ok) notifyChainFailure('mark this email as unread');
                }
                await removeMessageFromIndexedDb(message.id, pageType?.toLowerCase());
            }
        }
        catch (err) {
            const errorStr = toErrorString(err || err.message);
            reportError({
                endpoint: '/updateInsecureMail, ',
                message: `FileName: ContextMenu.js, Fun: handleReadEmail, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            console.error(err)
        }
        finally {
            loader(false);
            text("")
            reRender();

        }
    }
    return (
        <>
            {visible && (
                <div className="contextMenu copying-content" style={style}>
                    <div className="contextMenu--option-div" onClick={onClose} >

                        {(pageType !== 'Trash') && (
                            <>
                                <div className="contextMenu--option cursor-pointer archive_list" onClick={() => { actionClick(selectedContext, "Reply"); }}>
                                    <Reply className="pe-5px" />Reply
                                </div>
                                {/* "ReplyAll", not "Reply": the composer (ReplyModal in modals/common-alert.js)
                                    only pre-fills CC/BCC and the other original recipients on the "ReplyAll"
                                    branch. Sending "Reply" made this entry behave exactly like Reply above —
                                    everyone but the sender was silently dropped off the thread. */}
                                <div className="contextMenu--option cursor-pointer archive_list" onClick={() => { actionClick(selectedContext, "ReplyAll"); }}>
                                    <ReplyAll className="pe-5px" />ReplyAll
                                </div>
                                <div className="contextMenu--option cursor-pointer archive_list border-bottom-ccc" onClick={() => { actionClick(selectedContext, "Forward"); }}>
                                    <Forward className="pe-5px" />Forward
                                </div>
                            </>
                        )}

                        <div className='multi_levl_dropdown'>
                            <p className='folder_list' ><FolderInput className="pe-5px" />
                                Move to</p>
                            <div className='contextMenu-dropdown'>
                                {/* <input onChange={handleFilter} /> */}



                                {types.length > 0 && pageType !== 'Trash' && types.map((item, index) => (
                                    <div key={index} className="contextMenu--option cursor-pointer" onClick={() => handleOptionClick(item)}>
                                        <div className="contextMenu--option-div-line"> {folders.folderIcon[`${getColorFromJson(item)}Folder`]} </div>
                                        <div> Move to {item.name} </div>
                                    </div>
                                ))}
                                <div className="contextMenu--option cursor-pointer" onClick={() => handleFolder()}>
                                    <div className="contextMenu--option-div-line">{folders.folderIcon[`greenFolder`]}</div>
                                    <div>Create Folder</div>

                                </div>
                            </div>
                        </div>


                        {pageType === 'Trash' && selectedContext && (
                            selectedContext.mailtype === "web2emails" ? (
                                <>
                                    <div className="contextMenu--option cursor-pointer archive_list" onClick={() => restoreweb2email(selectedContext.id)}>
                                        <Inbox className="pe-5px" />Move to Inbox
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="contextMenu--option cursor-pointer archive_list" onClick={() => handleRestore()}>
                                        <Inbox className="pe-5px" />Move to Inbox
                                    </div>
                                </>
                            )
                        )}
                        {/* Move to Archive List */}

                        {pageType === 'Insecure' &&
                            <div className="contextMenu--option cursor-pointer archive_list" onClick={() => {
                                handleweb2emails(selectedContext.messageId, "TRUE")
                            }}>
                                <Archive className="pe-5px" />Move to Archive
                            </div>
                        }

                        {(pageType !== "Trash") &&
                            <div className="contextMenu--option cursor-pointer archive_list" onClick={() => {
                                handleSingleDelete(selectedContext)
                            }}>
                                <Trash2 className="pe-5px" />Delete
                            </div>
                        }
                        {(pageType === "Trash") &&
                            <div className="contextMenu--option cursor-pointer archive_list" onClick={() => {
                                deleteForever(selectedContext)
                            }}>
                                <Trash2 className="pe-5px" />Delete Forever
                            </div>
                        }
                        {markAsReadList && (pageType !== "Sent") &&
                            <div className="contextMenu--option cursor-pointer archive_list" onClick={() => {
                                handleReadEmail(selectedContext, "read")
                            }}>
                                <MailOpen className="pe-5px" />Mark as read
                            </div>
                        }
                        {!markAsReadList && (pageType !== "Sent") &&
                            <div className="contextMenu--option cursor-pointer archive_list" onClick={() => {
                                handleReadEmail(selectedContext, "unread")
                            }}>
                                <Mail className="pe-5px" />Mark as unread
                            </div>
                        }
                        {pageType === 'Archive' && selectedContext && (
                            selectedContext.mailtype === "web2emails" ? (
                                <div className="contextMenu--option cursor-pointer p-10-15" onClick={() => handleweb2emails(selectedContext.messageId, "FALSE")}>
                                    <Inbox className="pe-5px" />   Move to inbox
                                </div>
                            ) : (
                                <div className="contextMenu--option cursor-pointer p-10-15" onClick={() => handleArchive(false)}>
                                    <Inbox className="pe-5px" />   Move to inbox
                                </div>
                            )
                        )}

                        {isArchive &&
                            <>
                                <div className="contextMenu--option cursor-pointer archive_list" onClick={() => handleArchive(true)}>
                                    <Archive className="pe-5px" /> Move to Archive
                                </div>

                            </>
                        }


                    </div>
                </div >
            )}
        </>
    );
};

export default ContextMenu;
